import { apiClient } from './apiClient';

export const ACCOUNT_USER_PROFILE_BIRTH_SEASONS = [
  'early_year',
  'spring',
  'summer',
  'autumn',
  'winter',
] as const;

export type AccountUserProfileBirthSeason = typeof ACCOUNT_USER_PROFILE_BIRTH_SEASONS[number];

export const ACCOUNT_USER_PROFILE_HOROSCOPES = [
  'aries',
  'taurus',
  'gemini',
  'cancer',
  'leo',
  'virgo',
  'libra',
  'scorpio',
  'sagittarius',
  'capricorn',
  'aquarius',
  'pisces',
] as const;

export type AccountUserProfileHoroscope = typeof ACCOUNT_USER_PROFILE_HOROSCOPES[number];

export type AccountUserProfileRecord = {
  id: string;
  userId: string;
  birthYear: number | null;
  birthSeason: AccountUserProfileBirthSeason | null;
  horoscope: AccountUserProfileHoroscope | null;
  derivedAgeYears: number | null;
  schemaVersion: number;
  createdAt: string;
  updatedAt: string;
};

export type AccountUserProfileBlockRecord = {
  id: string;
  userId: string;
  blockType: string;
  schemaVersion: number;
  blockData: Record<string, unknown>;
  createdAt: string;
  updatedAt: string;
};

export type AccountUserProfileBundle = {
  profile: AccountUserProfileRecord;
  blocks: AccountUserProfileBlockRecord[];
};

export type LearningSequenceProfileBlock = {
  learningMode: 'weekday' | 'holiday';
  sequenceLength: number;
  weekdaySequenceLength: number;
  holidaySequenceLength: number;
  streamSequenceLengths?: Record<string, unknown>;
  dailyAlgorithm: string;
  sprintAlgorithm: string;
  includeIpttqInReviewSequence?: boolean;
  /** 衍生内容超前年龄（岁）0～10，默认 1 */
  contentAgeAheadYears?: number;
};

async function getProfileBundle(userId: string): Promise<AccountUserProfileBundle> {
  return apiClient.getEnvelope<AccountUserProfileBundle>(`/api/account-user-profile/${encodeURIComponent(userId)}`);
}

export const accountUserProfileService = {
  getProfileBundle,

  async patchDemographics(
    userId: string,
    patch: {
      birthYear?: number | null;
      birthSeason?: AccountUserProfileBirthSeason | null;
      horoscope?: AccountUserProfileHoroscope | null;
    },
  ): Promise<AccountUserProfileRecord> {
    return apiClient.patchEnvelope<AccountUserProfileRecord>(
      `/api/account-user-profile/${encodeURIComponent(userId)}/demographics`,
      patch,
    );
  },

  async getLearningSequence(userId: string): Promise<LearningSequenceProfileBlock> {
    return apiClient.getEnvelope<LearningSequenceProfileBlock>(
      `/api/account-user-profile/${encodeURIComponent(userId)}/learning-sequence`,
    );
  },

  async patchLearningSequence(
    userId: string,
    patch: Partial<LearningSequenceProfileBlock>,
  ): Promise<LearningSequenceProfileBlock> {
    return apiClient.patchEnvelope<LearningSequenceProfileBlock>(
      `/api/account-user-profile/${encodeURIComponent(userId)}/learning-sequence`,
      patch,
    );
  },
};
